import { render } from "./SvgIconDecorative.vue?vue&type=template&id=421c093e"
import script from "./SvgIconDecorative.vue?vue&type=script&lang=js"
export * from "./SvgIconDecorative.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__